import { render, staticRenderFns } from "./Classificacao.vue?vue&type=template&id=b8caba88&scoped=true"
import script from "./Classificacao.vue?vue&type=script&lang=js"
export * from "./Classificacao.vue?vue&type=script&lang=js"
import style0 from "./Classificacao.vue?vue&type=style&index=0&id=b8caba88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8caba88",
  null
  
)

export default component.exports